import Rest from '@/services/Rest';

/**
 * @typedef {UserSettingsService}
 */
export default class UserSettingsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/user-settings'
}
